import React from 'react';
import Header from "../components/Header/Header";
import "./SessionExpired.scss"

const SessionExpired = () => {
    return (
        <div>
            <Header selectedDealers={[]} displayHeaderControls={false}></Header>
            <div className='align-center'>
                <img alt="nodatafound" src="noDataFound.jpeg" className="session-timeout-image" />
                <span className="session-timeout-text">Your session has expired. Please log in again</span>
            </div>
        </div>
    )
}

export default SessionExpired;